/**
 * Waits for all CSS transition animations to complete on the provided element.
 */
export async function transitionsCompleted(
  element: HTMLElement,
  options?: GetAnimationsOptions,
): Promise<void> {
  const transitions = element
    .getAnimations(options)
    .filter((a) => a instanceof CSSTransition)
    .map((t) => t.finished);

  await Promise.all(transitions);
}
